import { Animation, Vector } from "excalibur";
import { derived } from "../../resources";
import { LevelOne } from "../../scenes/level-one/level-one";
import { range } from "../../util";
import { Tower } from "./tower";

export class MoneySeal extends Tower {
    static getSpec() {
        return {
            name: "Money Seal",
            icon: derived.moneySealIcon,
            cost: 100,
            description: "Gains money equal to the value of the dice roll.",
            factory: (level: LevelOne, pos: Vector) => new MoneySeal(level, pos.x, pos.y)
        }
    }

    getSpec() {
        return MoneySeal.getSpec();
    }

    constructor(level: LevelOne, x: number, y: number) {
        super(level, x, y, 0);
    }

    onInitialize() {
        super.onInitialize();

        const animation = Animation.fromSpriteSheet(
            derived.moneySealSpriteSheet,
            range(0, 6),
            100
        );

        this.graphics.use(
            animation
        );
    }    

    shoot(results: number[]) {
        this.level.money += results.reduce((a, b) => a + b, 0);
    }
}